import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { FC } from 'react'

/**
 * The last item should only have `label` (represents current view, not clickable).
 * Use either `href` OR `onClick` for navigation.
 */
export type BreadCrumb = { label: string } & ({ href?: string } | { onClick?: () => void })

export interface BreadCrumbsProps {
    items: BreadCrumb[]
}

const BreadCrumbs: FC<BreadCrumbsProps> = ({ items }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                gap: 1,
                overflow: 'hidden',
                flexWrap: 'nowrap',
            }}
        >
            {items.map((item, index) => {
                const href = 'href' in item ? item.href : undefined
                const onClick = 'onClick' in item ? item.onClick : undefined
                const isLast = index === items.length - 1
                return (
                    <>
                        <Link
                            variant={'body3'}
                            key={index}
                            href={href}
                            onClick={onClick}
                            title={item.label}
                            sx={{
                                color: isLast ? `TextPrimary` : `TextTertiary`,
                                textDecorationColor: isLast ? `TextPrimary` : `TextTertiary`,
                                textDecoration: 'none',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                pointerEvents: isLast ? 'none' : 'all',
                                ...((href || onClick) && {
                                    cursor: 'pointer',
                                    '&:hover': {
                                        color: `TextPrimary`,
                                        textDecoration: 'underline',
                                    },
                                }),
                            }}
                        >
                            {item.label}
                        </Link>
                        {!isLast && <Typography variant={`body3`}>/</Typography>}
                    </>
                )
            })}
        </Box>
    )
}

export default BreadCrumbs
